import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'TEMPO_DIRECAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('tempoDirecaoForm', registro)
    ];
}

export function getLista(dataInicial, dataFinal) {
    const request = axios.get(`${consts.API_URL}/tempoDirecao?data_inicial=${DateFormat.formatarDataTelaParaParametro(dataInicial)}&data_final=${DateFormat.formatarDataTelaParaParametro(dataFinal)}`);
    return {
        type: 'TEMPO_DIRECAO_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'TEMPO_DIRECAO_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'TEMPO_DIRECAO_VEICULO_SELECT_LISTADO',
        payload: request
    };
}
